import { useEffect } from 'react'
import HotkeyEvents from '@shared/ipc/HotkeyEvents.ts'

export const useHotkeyEvent = (eventName: string, callback: (...args: any[]) => void | Promise<void>) => {
  useEffect(() => {
    HotkeyEvents.on(eventName, callback)
    return () => {
      HotkeyEvents.off(eventName, callback)
    }
  }, [eventName, callback])
}
